import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../auth/UseUser";

const AdminRoute = ({ Component }: any) => {
  const { isSignedIn, user } = useUser();
  
  // Provera da li je korisnik ulogovan
  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }
  
  // Provera da li je korisnik administrator
  const isAdmin = user?.roleView?.name?.includes("Администратор");
  
  if (!isAdmin) {
    // Redirektuj neautorizovanog korisnika na home ili prikaži error
    return <Navigate to="/" replace />;
  }
  
  return <Component />;
};

export default AdminRoute;